import { XYCoord } from 'react-dnd';
import { AngleRange } from '../interfaces';

// Note: this should probably be replaced with `translate` from point.ts,
// but that function has typing issues (lodash curry 😢) that I didn't want to resolve at this moment
export function translatePoint(pointA: Partial<XYCoord>, pointB: Partial<XYCoord>) {
    return {
        x: (pointA.x || 0) + (pointB.x || 0),
        y: (pointA.y || 0) + (pointB.y || 0),
    };
}

export function distance(x1: number, y1: number, x2: number, y2: number) {
    return Math.sqrt(Math.pow(Math.abs(x2 - x1), 2) + Math.pow(Math.abs(y2 - y1), 2));
}

export function getAngle(x1: number, y1: number, x2: number, y2: number) {
    return (Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI + 180;
}

export function inAngleRanges(x1: number, y1: number, x2: number, y2: number, angleRanges: AngleRange[]) {
    const angle = getAngle(x1, y1, x2, y2);

    for (let i = 0; i < angleRanges.length; ++i) {
        if (
            (angleRanges[i].start == null || angle >= angleRanges[i].start) &&
            (angleRanges[i].end == null || angle <= angleRanges[i].end)
        ) {
            return true;
        }
    }

    return false;
}
